import { render } from "./StickyElement.vue?vue&type=template&id=7a0cdd68&scoped=true"
import script from "./StickyElement.vue?vue&type=script&lang=js"
export * from "./StickyElement.vue?vue&type=script&lang=js"

import "./StickyElement.vue?vue&type=style&index=0&id=7a0cdd68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0cdd68"]])

export default __exports__